var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"vue-json-query-builder bg-transparent",style:({ 'pointer-events': _vm.loading ? 'none' : 'all' }),attrs:{"elevation":"0"}},[(_vm.isVisible)?_c('b-card-body',{staticClass:"p-2 bg-transparent"},[_c('RuleGroup',{ref:"ruleGroup",attrs:{"current-query":_vm.query,"options":_vm.options,"userId":_vm.userId}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }